import { decamelize } from 'helpers/camelize';
import {
  fetchWrapper,
  handleResponse,
  hcUrlV3,
  buildOpts,
  transformMealResponse,
  objectToQueryString,
} from 'services/RequestService/helpers';

export const getNutritionalFacts = async ({ params }) => {
  const response = await fetchWrapper(
    hcUrlV3(
      `/nutritional_facts/${params.mealId}${params.packingFacility ? `?${objectToQueryString(decamelize({ packingFacility: params.packingFacility }, true))}` : ''}`
    ),
    buildOpts()
  );
  return handleResponse(response, transformMealResponse);
};
